import {useStoreCommunity} from "../store/hooks";
import Image from './image';

// generated by https://png-pixel.com/
const placeholderImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPc/x8AAoMBwP8UKJsAAAAASUVORK5CYII=';

const CommunityLogo = ({name, data}) => {
    const community = data || useStoreCommunity(name);
    const logoUrl = community?.icon ? `https://img.scored.co/community/${community.name.toLowerCase()}-icon-192x192.png?v=${community.icon_id}` : placeholderImage;
    return (
        <Image
            src={logoUrl || placeholderImage}
            alt={""}
            fallbackSrc={placeholderImage}
        />
    );
};

export default CommunityLogo;
